module.exports = __webpack_public_path__ + "4395e0f7ffd421f0997e17efc3ece79f.png";